import { IXeoLumPlus } from "./model";
import { AstCalendarService } from "src/app/services/sunTimes/suntimes.service";

// Calcular datos astronómicos para hoy (coordenadas de Getafe, Madrid)
const astService = new AstCalendarService();
const todaySunTimes = astService.getSunTimesForDate(new Date(), 40.3083, -3.7327);

// Objeto con los horarios calculados para usar en los schedulers
const todayAstro = {
  sunrise: todaySunTimes.sunriseStr || '07:25',
  sunset: todaySunTimes.sunsetStr || '18:35'
};

export const xeoLumPlus: IXeoLumPlus = {
  serial: 'XLP3-0001',
  name: 'XeoLum+ Demo',
  type: 'XLP3',
  alive: true,
  lastSeen: new Date().toISOString(),
  timeZone: 'Europe/Madrid',
  firmware: '2.1.0',
  location: { country: 'Spain', region: 'Madrid', city: 'Getafe', lat: 40.3083, lon: -3.7327 },
  temperature_C: 42.5,
  alarms: { state: true, overcurrent: true, voltageOutOfRange: { L1: false, L2: true, L3: false } },

  outputs: { output1: true, output2: false, output3: true, output4: false },

  inputs: [
    { name: 'IN1', state: true },
    { name: 'IN2', state: false },
    { name: 'IN3', state: true },
    { name: 'IN4', state: false },
    { name: 'IN5', state: false },
    { name: 'IN6', state: true },
    { name: 'IN7', state: true },
    { name: 'IN8', state: false },
    { name: 'IN9', state: false },
    { name: 'IN10', state: true }
  ],

  counters: {
    device: { totalRunHours_h: 3620.5, lastReset: '2025-01-01T00:00:00Z' },
    partial: { since: '2025-10-01T00:00:00Z', runHours_h: 168.3, activeEnergy_kWh: 42.9, lastPartialReset: '2025-10-01T00:00:00Z' },
    perOutput: {
      output1: { runHours_h: 92.5, activeEnergy_kWh: 18.2 },
      output2: { runHours_h: 35.1, activeEnergy_kWh: 8.6 },
      output3: { runHours_h: 58.4, activeEnergy_kWh: 13.7 },
      output4: { runHours_h: 22.3, activeEnergy_kWh: 2.4 }
    }
  },

  scheduler: {
    output1: [{ type: 'sunset', time: todayAstro.sunset, offset: 0, days: 31, action: 1 }, { type: 'sunrise', time: todayAstro.sunrise, offset: 0, days: 126, action: 0 },
      { type: 'fixed', time: '12:00', offset: 0, days: 127, action: 1 },{ type: 'fixed', time: '14:30', offset: 0, days: 127, action: 0 }
    ],
    output2: [{ type: 'fixed', time: '12:00', offset: 0, days: 96, action: 1 }, { type: 'fixed', time: '20:00', offset: 0, days: 96, action: 0 }],
    output3: [{ type: 'fixed', time: '06:30', offset: 0, days: 127, action: 1 }, { type: 'fixed', time: '23:00', offset: 0, days: 127, action: 0 }],
    output4: [{ type: 'sunset', time: todayAstro.sunset, offset: 10, days: 62, action: 1 }, { type: 'sunrise', time: todayAstro.sunrise, offset: -10, days: 62, action: 0 }]
  },

  config: {
    overcurrentAlarm: { enabled: true, perPhaseThreshold_A: { L1: 4.0, L2: 4.0, L3: 4.0 }, hysteresis_A: 0.4, delay_ms: 2000 },
    voltageAlarm: {
      enabled: true,
      perPhaseRange_V: {
        L1: { min: 200, max: 253 },
        L2: { min: 200, max: 253 },
        L3: { min: 200, max: 253 }
      },
      hysteresis_V: 2.0,
      delay_ms: 3000
    },
    slaveDevices: {
      autoDiscover: true,
      maxSlaves: 8,
      expected: [
        { address: 1, model: 'XeoSwitch-1', required: true },
        { address: 2, model: 'XeoSwitch-2', required: false }
      ],
      retryPolicy: { attempts: 3, backoff_ms: 500 }
    }
  },

  history: {
    recentDays: [
      { date: '2025-10-23', energy_kWh: 6.35, avgPower_W: 265, maxPower_W: 760, outputsOn: ['output1', 'output3'], alarms: [] },
      { date: '2025-10-24', energy_kWh: 6.12, avgPower_W: 255, maxPower_W: 745, outputsOn: ['output1', 'output3'], alarms: ['voltage_sag_L2'] }
    ],
    cycles: [
      { output: 'output1', start: '2025-10-29T18:35:00Z', end: '2025-10-30T07:25:00Z', duration_h: 12.83, energy_kWh: 3.12, avgPower_W: 243, maxPower_W: 360 }
    ],
    events: [
      { ts: '2025-10-28T21:12:03Z', type: 'alarm', code: 'overcurrent_L3', message: 'Sobrecorriente detectada en L3', clearedTs: '2025-10-28T21:12:07Z' }
    ]
  },

  externalAnalyzers: [
    {
      id: 'ANZ-01',
      name: 'Analyzer Feeder A',
      model: 'XeoAnalyzer-3P',
      firmware: '1.0.0',
      online: true,
      lastSeen: new Date(Date.now() - 30_000).toISOString(),
      monitoredCircuit: 'Feeder A / Alumbrado Vía 1',
      ctRatio: { primary_A: 200, secondary_A: 5 },
      electricalParams: {
        perPhase: [
          { phase: 'L1', voltage_V: 231.2, current_A: 2.15, activePower_W: 440.0, apparentPower_VA: 497.0, powerFactor: 0.89, frequency_Hz: 50.0, energy_kWh: 1210.3 },
          { phase: 'L2', voltage_V: 230.4, current_A: 1.98, activePower_W: 405.5, apparentPower_VA: 456.0, powerFactor: 0.89, frequency_Hz: 50.0, energy_kWh: 1188.7 },
          { phase: 'L3', voltage_V: 232.0, current_A: 2.05, activePower_W: 422.1, apparentPower_VA: 474.0, powerFactor: 0.89, frequency_Hz: 50.0, energy_kWh: 1201.6 }
        ],
        totals: {
          avgVoltage_V: 231.2,
          avgCurrent_A: 2.06,
          totalActivePower_W: 1267.6,
          totalApparentPower_VA: 1427.0,
          totalEnergy_kWh: 3600.6,
          partialEnergy_kWh: 150.2,
          frequency_Hz: 50.0,
          temperature_C: 38.5
        }
      }
    },
    {
      id: 'ANZ-02',
      name: 'Analyzer Feeder B',
      model: 'XeoAnalyzer-3P',
      firmware: '1.0.0',
      online: false,
      lastSeen: new Date(Date.now() - 7200_000).toISOString(),
      monitoredCircuit: 'Feeder B / Parking',
      ctRatio: { primary_A: 100, secondary_A: 5 },
      electricalParams: {
        perPhase: [
          { phase: 'L1', voltage_V: 229.8, current_A: 0.95, activePower_W: 190.2, apparentPower_VA: 218.0, powerFactor: 0.87, frequency_Hz: 50.0, energy_kWh: 520.4 },
          { phase: 'L2', voltage_V: 230.1, current_A: 1.02, activePower_W: 205.3, apparentPower_VA: 235.0, powerFactor: 0.87, frequency_Hz: 50.0, energy_kWh: 534.7 },
          { phase: 'L3', voltage_V: 230.6, current_A: 0.98, activePower_W: 197.9, apparentPower_VA: 226.0, powerFactor: 0.88, frequency_Hz: 50.0, energy_kWh: 528.6 }
        ],
        totals: {
          avgVoltage_V: 230.2,
          avgCurrent_A: 0.98,
          totalActivePower_W: 593.4,
          totalApparentPower_VA: 679.0,
          totalEnergy_kWh: 1583.7,
          partialEnergy_kWh: 65.4,
          frequency_Hz: 49.5,
          temperature_C: 36.9
        }
      }
    }
  ],

    // Esclavos monofásicos XeoSwitch
  slaves: [
    {
      address: 1,
      model: 'XeoSwitch-1',
      firmware: '1.4.2',
      online: true,
      lastSeen: new Date(Date.now() - 60000).toISOString(),
      role: 'meter',
      notes: 'Armario A',
      electrical: {
        voltage_V: 230.8,
        current_A: 0.85,
        activePower_W: 185.2,
        energy_kWh: 420.5,
        frequency_Hz: 50.0,
        temperature_C: 39.4
      },
      scheduler: {
        output1: [{ type: 'sunset', time: todayAstro.sunset, offset: 0, days: 31, action: 1 }, { type: 'sunrise', time: todayAstro.sunrise, offset: 0, days: 31, action: 0 }]
      },
      outState: true
    },
    {
      address: 2,
      model: 'XeoSwitch-2',
      firmware: '1.3.0',
      online: false,
      lastSeen: new Date(Date.now() - 3600 * 1000).toISOString(),
      role: 'relay-controller',
      notes: 'Vía peatonal',
      electrical: {
        voltage_V: 229.6,
        current_A: 0.0,
        activePower_W: 0.0,
        energy_kWh: 210.1,
        frequency_Hz: 50.0
      },
      scheduler: {
        output1: [{ type: 'fixed', time: '12:00', offset: 0, days: 96, action: 1 }, { type: 'fixed', time: '20:00', offset: 0, days: 96, action: 0 }],

      },
      outState: false
    }
  ],
};
